import { UsersFormComponent } from './users-form/users-form.component';
import { NgModule } from '@angular/core';
import { UsersComponent } from './users.component';
import { Routes, RouterModule } from '@angular/router';
import { UsersDetailComponent } from './users-detail/users-detail.component';
import { RoleGuard } from 'src/app/shared/guards/role.guard';

const routes:Routes=[
  {path:'',redirectTo:'list',pathMatch:'full'},
  {path:'list',component:UsersComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager']}},
  {path:'new',component:UsersFormComponent,canActivate:[RoleGuard],data:{roles: ["admin"]}},
  {path:'edit',component:UsersFormComponent,canActivate:[RoleGuard],data:{roles: ["admin"]}},
  {path:'detail',component:UsersDetailComponent,canActivate:[RoleGuard],data:{roles: ["user", "admin",'manager']}}
]

  // o Administrador Khuzela faz CRUD
  // o Utilizador Khuzela  só Lê
  // o Manager do Clube só Lê
  // o Utilizador do Clube só Lê


@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports:[
    RouterModule
  ]
})
export class UsersRoutingModule { }
